import { FLAG } from '@shared/products-types';

import type { Dashboard } from '../../types/Dashboard';

export const dashboardHUFeatureConfig: Dashboard = {
    hidePerformanceForFlags: [],
    hideSettingsForFlags: [FLAG.junior],
};
